import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: true,
        themes: {
            dark: {

                // Základní barvy
                // zelená
                primary: '#4caf50',
                //hnědá
                secondary: '#795548',
                //oranžová - důraz
                accent: '#ff5722',
                //červená
                error: '#f44336',
                // fialová - varování
                warning: '#9c27b0',
                // modro fialová
                info: '#673ab7',
                //tyrkysová - úspěch
                success: '#009688',


                // další barvy
                // tmavě zelenější než primary
                primary2: '#006c44',
                // žlutější než oranžová accent
                accent2: '#FFC107',
                // Světle šedá - nastrojová lišta
                toolBar1: '#363636',
                // Tmavě šedá - nastrojová lišta
                toolBar2: '#272727',
                // Ještě světlejší šedá  - nastrojová lišta
                toolBar3: '#545454',

                // modrá KN
                colorKn: '#246591',

                // PSK
                colorPSK: '#008000',
                // BZL
                colorBZL: '#00BF00',
                // JP
                colorJP: '#808000',
                // OP
                colorOP: '#BFBF00',

                // barva mapové legendy úroveň 1
                mapLegendGroupColor1: '#006c44',
                // barva mapové legendy úroveň 1
                mapLegendGroupColor2: '#795548',
                // barva mapové legendy úroveň 1
                mapLegendGroupColor3: '#009688',

            }


        }

    }

});
